import { render } from "./DemoSidebar.vue?vue&type=template&id=629de238&scoped=true"
import script from "./DemoSidebar.vue?vue&type=script&lang=js"
export * from "./DemoSidebar.vue?vue&type=script&lang=js"

import "./DemoSidebar.vue?vue&type=style&index=0&id=629de238&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629de238"]])

export default __exports__